var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'main-header': true, expanded: !_vm.sidebarMenuCollapsed}},[_c('div',{staticClass:"top-menu"},[(_vm.isExecutionPage)?_c('ExecutionDetails'):_c('WorkflowDetails')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }